export const createOrganizationSchema = (siteUrl: string) => {
	const normalizedSiteUrl = siteUrl.replace(/\/+$/, '');

	return {
		'@context': 'https://schema.org',
		'@type': 'Organization',
		'@id': `${normalizedSiteUrl}/#organization`,
		name: 'Gogeta',
		legalName: 'Velomatch Limited',
		alternateName: 'Velomatch Limited t/a gogeta',
		url: `${normalizedSiteUrl}/`,
		description:
			'Gogeta is a UK employee benefits provider offering salary sacrifice benefits for cycle to work and workplace nursery partnerships.',
		logo: {
			'@type': 'ImageObject',
			url: `${normalizedSiteUrl}/og-image.png`,
		},
		address: {
			'@type': 'PostalAddress',
			streetAddress: 'Birchin Court, 20 Birchin Lane',
			addressLocality: 'London',
			postalCode: 'EC3V 9DU',
			addressCountry: 'GB',
		},
		sameAs: ['https://www.linkedin.com/company/gogetabenefits/home/'],
	};
};
